import { Paper, Typography } from '@mui/material'
import { Box, useTheme } from '@mui/system'
import React from 'react'
import Introduction from './Introduction'
import SideNavigationLists from './side-nav-lists/SideNavigationLists'
import AuthApi from './AuthApi'
import VehicleApis from './VehicleApis'
import AlertTypes from './alert-types/AlertTypes'
import TimestampFormat from './timestamp-format/TimestampFormat'
import StatusCodes from './status-codes/StatusCodes'

const SideNavApi = () => {
  const theme = useTheme();
    return (
        <Box className="flex-1 grid grid-cols-5">
            <Box className="col-span-1 flex gap-4 p-4 sticky h-screen overflow-auto overScrollBehavior-contain top-0" sx={{
                backgroundColor: theme.palette.selected
            }}>
                <Box className='flex flex-col overflow-y-auto mb-20 w-full'>
                    <Box className="flex items-center gap-2 p-3 mt-2 line-clamp-2" sx={{
                        backgroundColor: theme.palette.selected
                    }}>
                        <Typography variant="body2" fontWeight={600} fontSize={13}>[PROD] Novus OmniFleet Developer APIs</Typography>
                    </Box>
                    <SideNavigationLists />
                </Box>
            </Box>
            <Paper className="col-span-4 flex flex-col gap-4 p-4">
                <Box id='intro'>
                    <Introduction />
                </Box>
                <Box id='authentication'>
                    <AuthApi />
                </Box>
                <Box id='vehicles'>
                    <VehicleApis />
                </Box>
                <Box id='alert-types'>
                    <AlertTypes />
                </Box>
                <Box id='timestamp-format'>
                    <TimestampFormat />
                </Box>
                <Box id='status-codes'>
                    <StatusCodes />
                </Box>
            </Paper>
        </Box>
    )
}

export default SideNavApi